export default __webpack_public_path__ + "static/media/boating_vacation.3adf0a5a.webp";